import { apiClient } from './apiClient';
export const requestAccess = async () => {
    const response = await apiClient({
        method: 'POST',
        url: '/api/v1/request-access/shipments',
        data: {},
    });
    return response.data;
};
